import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import PropTypes from 'prop-types';

const InputText = ({name, className = 'form-control', defaultValue, ...rest}) => {
  const {register, errors} = useFormContext();

  const style = {height: '45px', border: 'solid 0.5px var(--color-dark)'}

  return (
    <>
        <input
          className={`${className} ${errors[name] && 'error-field'}`}
          type="text"
          ref={register}
          name={name}
          defaultValue={defaultValue}
          style={style}
          {...rest}
        />
      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default InputText;

InputText.propTypes = {
  name: PropTypes.string.isRequired,
};
